// Imports useState and useEffect hooks from React for managing state and side effects in functional components.
import { useState, useEffect } from "react";

// Defines a custom hook named useFetch, which takes an apiPath and an optional queryTerm parameter for fetching data from an API.
export const useFetch = (apiPath, queryTerm="") => {
    // Initializes the data state as an empty array. This state will store the fetched data.
    const [data, setData] = useState([]);

    // Constructs the URL for the API request using the apiPath and queryTerm. It includes your API key from the environment variables.
    const url = `https://api.themoviedb.org/3/${apiPath}?api_key=${process.env.REACT_APP_API_KEY}&query=${queryTerm}`

    // useEffect hook to perform the fetch operation when the url changes.
    useEffect(() => {
        // Defines an asynchronous function fetchMovies to fetch data from the API.
        async function fetchMovies(){
          // Waits for the fetch request to complete and stores the response.
          const response = await fetch(url);
          // Parses the JSON body of the response.
          const json = await response.json();
          // Updates the data state with the results from the JSON payload.
          setData(json.results);
        }
        // Calls the fetchMovies function to perform the fetch operation.
        fetchMovies();
      // Adds url to the dependency array of useEffect, so the effect runs again if url changes.
      }, [url])

  // Returns an object with the data state, making it available to components that use this hook.
  return { data }
}

